import type { Collection, Metaobject, Product, Customer } from "@shopify/hydrogen-react/storefront-api-types";
import type { ICollectionMetafields } from "../queries/collection-gql";
import type { IProductMetafields } from "../queries/product-gql";

// 멤버십 유효성 확인
export const checkMembershipAccessible = (
  data: (Collection & ICollectionMetafields) | (Product & IProductMetafields) | Metaobject | undefined,
  customer: Customer,
) => {
  let accessibleMemberships: string[] = [];

  if (data?.__typename === "Metaobject") {
    accessibleMemberships = JSON.parse(
      data.fields.find((item) => item.key === "accessible_memberships")?.value || "[]",
    );
  } else if (data?.__typename === "Collection" || data?.__typename === "Product") {
    accessibleMemberships = JSON.parse(data.accessible_memberships?.value || "[]");
  }

  if (accessibleMemberships.length > 0) {
    return customer.tags.some((tag) => accessibleMemberships.includes(tag));
  }

  return true;
};
